var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "optix-dashboard container-fluid p-0 m-0 mt-4" },
    [
      _c(
        "div",
        {
          staticClass: "dashboard-card",
          style: { border: _vm.activeReportUrl ? "none" : "" },
        },
        [
          !_vm.activeReportUrl
            ? _c("div", { staticClass: "dashboard-header-row mb-3" }, [
                _c("div", { staticClass: "shrink-0" }, [
                  _c("h5", { staticClass: "dashboard-title mb-1" }, [
                    _vm._v("\n          Dashboard\n        "),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "dashboard-subtitle mb-0" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.trackedCount) +
                        " " +
                        _vm._s(
                          _vm.trackedCount === 1 ? "product" : "products"
                        ) +
                        " " +
                        _vm._s(_vm.search.trim() ? "found" : "tracked") +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "kpi-center-slot" }, [
                  !_vm.kpiCollapsed && _vm.kpiCards.length
                    ? _c("div", { staticClass: "kpi-cards-wrap" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center flex-wrap gap-1.5 min-w-0",
                          },
                          _vm._l(_vm.kpiCards, function (card, cardIdx) {
                            return _c(
                              "button",
                              {
                                key: card.id,
                                staticClass: "kpi-card",
                                class: _vm.kpiCardColorClass(card.percent),
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip",
                                  "data-placement": "bottom",
                                  "data-html": "true",
                                  "data-boundary": "window",
                                  "data-original-title":
                                    _vm.kpiCardTooltip(card),
                                },
                                on: { click: _vm.toggleKpiDisplay },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-semibold tabular-nums" },
                                  [
                                    _vm.kpiShowCount
                                      ? [
                                          _vm._v(
                                            _vm._s(card.needCount) +
                                              "/" +
                                              _vm._s(card.total)
                                          ),
                                        ]
                                      : [_vm._v(_vm._s(card.percent) + "%")],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "font-medium" }, [
                                  _vm._v(_vm._s(_vm.kpiCardLabels[cardIdx])),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex items-center gap-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "kpi-toggle-btn",
                              attrs: {
                                type: "button",
                                title: "Toggle percent / count",
                              },
                              on: { click: _vm.toggleKpiDisplay },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.kpiShowCount ? "#" : "%") +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "kpi-collapse-btn",
                              attrs: { type: "button", title: "Collapse" },
                              on: {
                                click: function ($event) {
                                  _vm.kpiCollapsed = true
                                },
                              },
                            },
                            [
                              _c("ChevronUp", {
                                attrs: { width: "14", height: "14" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm.kpiCollapsed && _vm.kpiCards.length
                    ? _c(
                        "button",
                        {
                          staticClass: "kpi-expand-btn",
                          attrs: { type: "button", title: "Show KPI rollup" },
                          on: {
                            click: function ($event) {
                              _vm.kpiCollapsed = false
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "kpi-expand-badge" }, [
                            _vm._v(_vm._s(_vm.kpiTotalNeedCount)),
                          ]),
                          _vm._v("\n          Need optimization\n          "),
                          _c("ChevronDown", {
                            staticClass: "kpi-expand-chevron",
                            attrs: { width: "14", height: "14" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dashboard-header-actions shrink-0" },
                  [
                    _vm.checkedProductIds.length === 0
                      ? _c("div", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 px-4 py-2 h-9 gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm optimize-catalog-btn",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openOptimizeCatalogModal()
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "lucide lucide-zap h-4 w-4",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v("\n            Optimize\n          "),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "optimize-split-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "optimize-split-main",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openOptimizeCatalogModal(true)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "lucide lucide-zap h-4 w-4",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n            Optimize " +
                                  _vm._s(_vm.checkedProductIds.length) +
                                  " selected\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "optimize-split-clear",
                              attrs: {
                                type: "button",
                                title: "Clear selection",
                              },
                              on: { click: _vm.clearCheckedProducts },
                            },
                            [_c("X", { attrs: { width: "14", height: "14" } })],
                            1
                          ),
                        ]),
                    _vm._v(" "),
                    !_vm.activeReportUrl
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: () => _vm.closeFiltersPopover("header"),
                                expression:
                                  "() => closeFiltersPopover('header')",
                              },
                            ],
                            staticClass: "filters-popover-wrap",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-filters",
                                class: {
                                  active: _vm.openFiltersMenu === "header",
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleFiltersPopover("header")
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("polygon", {
                                      attrs: {
                                        points:
                                          "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v("\n            Filters\n            "),
                                _vm.activeFilterCount > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "filter-count-badge" },
                                      [_vm._v(_vm._s(_vm.activeFilterCount))]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.openFiltersMenu === "header"
                              ? _c(
                                  "DashboardFiltersPopover",
                                  _vm._g(
                                    _vm._b(
                                      {},
                                      "DashboardFiltersPopover",
                                      _vm.filtersPopoverProps,
                                      false
                                    ),
                                    _vm.filtersPopoverListeners
                                  )
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-compare",
                        class: { active: _vm.compareMode },
                        attrs: {
                          type: "button",
                          "aria-pressed": String(_vm.compareMode),
                        },
                        on: {
                          click: function ($event) {
                            _vm.compareMode = !_vm.compareMode
                          },
                        },
                      },
                      [
                        _c("GitCompareArrows", { attrs: { width: "18" } }),
                        _vm._v("\n          Compare\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "view-mode-toggle" }, [
                      _c(
                        "button",
                        {
                          staticClass: "view-mode-btn",
                          class: { active: _vm.viewMode === "table" },
                          attrs: {
                            type: "button",
                            title: "Table view",
                            "aria-label": "Table view",
                          },
                          on: {
                            click: function ($event) {
                              _vm.viewMode = "table"
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("path", { attrs: { d: "M12 3v18" } }),
                              _vm._v(" "),
                              _c("rect", {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  x: "3",
                                  y: "3",
                                  rx: "2",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M3 9h18" } }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M3 15h18" } }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "view-mode-btn",
                          class: { active: _vm.viewMode === "chart" },
                          attrs: {
                            type: "button",
                            title: "Chart view",
                            "aria-label": "Chart view",
                          },
                          on: {
                            click: function ($event) {
                              _vm.viewMode = "chart"
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("line", {
                                attrs: {
                                  x1: "18",
                                  x2: "18",
                                  y1: "20",
                                  y2: "10",
                                },
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: {
                                  x1: "12",
                                  x2: "12",
                                  y1: "20",
                                  y2: "4",
                                },
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: { x1: "6", x2: "6", y1: "20", y2: "14" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-outer" }, [
                      _c("div", { staticClass: "search-wrap" }, [
                        _c("i", { staticClass: "bi bi-search" }),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search,
                              expression: "search",
                            },
                          ],
                          ref: "searchInput",
                          staticClass: "form-control search-input",
                          attrs: {
                            placeholder: "Search products...",
                            rows: "1",
                          },
                          domProps: { value: _vm.search },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.search = $event.target.value
                              },
                              _vm.resizeSearchInput,
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.search
                          ? _c(
                              "button",
                              {
                                staticClass: "search-clear-btn",
                                attrs: { type: "button" },
                                on: { click: _vm.clearSearch },
                              },
                              [_c("i", { staticClass: "bi bi-x-lg" })]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.searchError
                        ? _c("span", { staticClass: "search-error-msg" }, [
                            _vm._v(_vm._s(_vm.searchError)),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown dashboard-actions-dropdown" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropdown-menu dropdown-menu-right" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: {
                                  href: "/admin/auth/settings/reports/dashboard",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Configure Dashboard...\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openSendToEmailModal.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Send to Email\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: {
                                  href: "#",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.updateScores.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Update Scores\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: {
                                  href: "#",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.refreshReports.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Refresh Reports\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.download.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v("\n              Download\n            ")]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeReportUrl
            ? _c(
                "div",
                {
                  staticClass: "report-details-container",
                  attrs: { id: "reportDetailsContainer" },
                },
                [
                  _c("div", { staticClass: "report-iframe-container" }, [
                    _vm.isReportLoading
                      ? _c(
                          "div",
                          {
                            staticClass: "report-loading-overlay",
                            attrs: { id: "reportLoadingOverlay" },
                          },
                          [_vm._m(1)]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("iframe", {
                      staticClass: "report-iframe",
                      attrs: {
                        id: "reportIframe",
                        src: _vm.activeReportUrl,
                        frameborder: "0",
                      },
                      on: { load: _vm.handleIframeLoad },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.compareMode && !_vm.activeReportUrl
            ? _c("div", { staticClass: "dashboard-controls-row mt-4" }, [
                _c("div", { staticClass: "compare-controls" }, [
                  _c(
                    "div",
                    { staticClass: "filter-inline compare-filter-inline" },
                    [
                      _c("span", { staticClass: "filter-label" }, [
                        _vm._v("Before"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.beforeRange,
                              expression: "beforeRange",
                            },
                          ],
                          staticClass: "form-control filter-select",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.beforeRange = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "1_week_ago" } }, [
                            _vm._v("\n              ~1 week ago\n            "),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2_weeks_ago" } }, [
                            _vm._v(
                              "\n              ~2 weeks ago\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "30_days_ago" } }, [
                            _vm._v(
                              "\n              ~30 days ago\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "60_days_ago" } }, [
                            _vm._v(
                              "\n              ~60 days ago\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "90_days_ago" } }, [
                            _vm._v(
                              "\n              ~90 days ago\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "custom" } }, [
                            _vm._v(
                              "\n              Custom date...\n            "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.beforeRange === "custom"
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: () => _vm.closeDatePicker("before"),
                              expression: "() => closeDatePicker('before')",
                            },
                          ],
                          staticClass: "date-picker compare-date-picker",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "date-input-wrap",
                              class: {
                                "is-open": _vm.activeDatePicker === "before",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDatePicker("before")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-calendar3" }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.beforeCustomDate,
                                    expression: "beforeCustomDate",
                                  },
                                ],
                                staticClass: "form-control date-input",
                                attrs: {
                                  type: "text",
                                  placeholder: "Before date",
                                  readonly: "",
                                },
                                domProps: { value: _vm.beforeCustomDate },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.beforeCustomDate = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.beforeCustomDate
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "date-clear-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.clearDatePickerValue(
                                            "before"
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-x" })]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.activeDatePicker === "before"
                            ? _c(
                                "div",
                                { staticClass: "date-picker-popover" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "date-picker-header" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "date-nav-btn",
                                          attrs: { type: "button" },
                                          on: { click: _vm.goToPreviousMonth },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-chevron-left",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "date-picker-title" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.currentMonthLabel) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "date-nav-btn",
                                          attrs: { type: "button" },
                                          on: { click: _vm.goToNextMonth },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-chevron-right",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-weekdays" },
                                    _vm._l(_vm.weekDays, function (day) {
                                      return _c("span", { key: day }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(day) +
                                            "\n              "
                                        ),
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-days" },
                                    _vm._l(_vm.calendarDays, function (day) {
                                      return _c(
                                        "button",
                                        {
                                          key: day.key,
                                          staticClass: "date-day",
                                          class: {
                                            "is-muted": !day.isCurrentMonth,
                                            "is-today": day.isToday,
                                            "is-selected": day.isSelected,
                                            "is-disabled": day.isDisabled,
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled: day.isDisabled,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectDatePickerValue(
                                                day.date
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(day.label) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "compare-vs-label" }, [
                    _vm._v("vs"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-inline compare-filter-inline" },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.afterType,
                              expression: "afterType",
                            },
                          ],
                          staticClass: "form-control filter-select",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.afterType = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "Most Recent" } }, [
                            _vm._v("\n              Most Recent\n            "),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Custom date..." } }, [
                            _vm._v(
                              "\n              Custom date...\n            "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.afterType === "Custom date..."
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: () => _vm.closeDatePicker("after"),
                              expression: "() => closeDatePicker('after')",
                            },
                          ],
                          staticClass: "date-picker compare-date-picker",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "date-input-wrap",
                              class: {
                                "is-open": _vm.activeDatePicker === "after",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDatePicker("after")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-calendar3" }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.afterCustomDate,
                                    expression: "afterCustomDate",
                                  },
                                ],
                                staticClass: "form-control date-input",
                                attrs: {
                                  type: "text",
                                  placeholder: "After date",
                                  readonly: "",
                                },
                                domProps: { value: _vm.afterCustomDate },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.afterCustomDate = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.afterCustomDate
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "date-clear-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.clearDatePickerValue(
                                            "after"
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-x" })]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.activeDatePicker === "after"
                            ? _c(
                                "div",
                                { staticClass: "date-picker-popover" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "date-picker-header" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "date-nav-btn",
                                          attrs: { type: "button" },
                                          on: { click: _vm.goToPreviousMonth },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-chevron-left",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "date-picker-title" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.currentMonthLabel) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "date-nav-btn",
                                          attrs: { type: "button" },
                                          on: { click: _vm.goToNextMonth },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-chevron-right",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-weekdays" },
                                    _vm._l(_vm.weekDays, function (day) {
                                      return _c("span", { key: day }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(day) +
                                            "\n              "
                                        ),
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-days" },
                                    _vm._l(_vm.calendarDays, function (day) {
                                      return _c(
                                        "button",
                                        {
                                          key: day.key,
                                          staticClass: "date-day",
                                          class: {
                                            "is-muted": !day.isCurrentMonth,
                                            "is-today": day.isToday,
                                            "is-selected": day.isSelected,
                                            "is-disabled": day.isDisabled,
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled: day.isDisabled,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectDatePickerValue(
                                                day.date
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(day.label) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.viewMode === "table" && !_vm.activeReportUrl && _vm.showEmptyState
            ? _c("div", { staticClass: "dashboard-empty-state mt-4" }, [
                _c(
                  "div",
                  { staticClass: "empty-state-icon" },
                  [_c("FolderOpen", { attrs: { width: "24", height: "24" } })],
                  1
                ),
                _vm._v(" "),
                _c("h3", { staticClass: "empty-state-title" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.emptyStateTitle) + "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: () => _vm.closeFiltersPopover("empty-state"),
                        expression: "() => closeFiltersPopover('empty-state')",
                      },
                    ],
                    staticClass: "empty-state-picker",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn empty-state-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleFiltersPopover("empty-state")
                          },
                        },
                      },
                      [
                        _c("FolderOpen", {
                          attrs: { width: "16", height: "16" },
                        }),
                        _vm._v("\n          Choose a product list\n          "),
                        _vm.openFiltersMenu === "empty-state"
                          ? _c("ChevronUp", {
                              attrs: { width: "16", height: "16" },
                            })
                          : _c("ChevronDown", {
                              attrs: { width: "16", height: "16" },
                            }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.openFiltersMenu === "empty-state"
                      ? _c(
                          "DashboardFiltersPopover",
                          _vm._g(
                            _vm._b(
                              { staticClass: "empty-state-popover" },
                              "DashboardFiltersPopover",
                              _vm.filtersPopoverProps,
                              false
                            ),
                            _vm.filtersPopoverListeners
                          )
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm.viewMode === "table" && !_vm.activeReportUrl
            ? _c(
                "div",
                {
                  ref: "tableWrap",
                  staticClass: "table-responsive dashboard-table-wrap mt-4",
                },
                [
                  _c("table", { staticClass: "table dashboard-table mb-0" }, [
                    _c(
                      "thead",
                      [
                        _vm.isSingleReportHeader
                          ? [
                              _c(
                                "tr",
                                { staticClass: "compact-head-row" },
                                [
                                  _c("th", { staticClass: "check-col" }, [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        "aria-label": "Select all products",
                                      },
                                      domProps: { checked: _vm.allChecked },
                                      on: { change: _vm.toggleAllChecked },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "SortableTh",
                                    {
                                      staticClass: "product-col",
                                      attrs: {
                                        "sort-key": "product",
                                        "active-key": _vm.sortKey,
                                        dir: _vm.sortDir,
                                      },
                                      on: { sort: _vm.toggleSort },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Product\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SortableTh",
                                    {
                                      staticClass: "metric-col",
                                      attrs: {
                                        "sort-key": "optix",
                                        "active-key": _vm.sortKey,
                                        dir: _vm.sortDir,
                                      },
                                      on: { sort: _vm.toggleSort },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Optix™ Score\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.orderedConfigs, function (config) {
                                    return [
                                      config.is_pdp
                                        ? [
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "single-before-group-" +
                                                      config.id,
                                                    staticClass:
                                                      "metric-col group-divider-left",
                                                    attrs: {
                                                      "sort-key":
                                                        "before:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedBeforeLabel
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "SortableTh",
                                              {
                                                key:
                                                  "single-text-group-" +
                                                  config.id,
                                                staticClass: "metric-col",
                                                class: {
                                                  "group-divider-left":
                                                    !_vm.compareMode,
                                                },
                                                attrs: {
                                                  "sort-key":
                                                    "text:" + config.id,
                                                  "active-key": _vm.sortKey,
                                                  dir: _vm.sortDir,
                                                },
                                                on: { sort: _vm.toggleSort },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Text\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "SortableTh",
                                              {
                                                key:
                                                  "single-images-group-" +
                                                  config.id,
                                                staticClass: "metric-col",
                                                attrs: {
                                                  "sort-key":
                                                    "images:" + config.id,
                                                  "active-key": _vm.sortKey,
                                                  dir: _vm.sortDir,
                                                },
                                                on: { sort: _vm.toggleSort },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Images\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "single-delta-group-" +
                                                      config.id,
                                                    staticClass: "delta-col",
                                                    attrs: {
                                                      "sort-key":
                                                        "delta:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Δ\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "single-before-group-" +
                                                      config.id,
                                                    staticClass:
                                                      "metric-col group-divider-left",
                                                    attrs: {
                                                      "sort-key":
                                                        "before:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedBeforeLabel
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.getFlatConfigCustomFields(
                                              config
                                            ).length
                                              ? _vm._l(
                                                  _vm.getFlatConfigCustomFields(
                                                    config
                                                  ),
                                                  function (field, fieldIndex) {
                                                    return _c(
                                                      "SortableTh",
                                                      {
                                                        key:
                                                          "single-custom-field-head-" +
                                                          config.id +
                                                          "-" +
                                                          field.key,
                                                        staticClass:
                                                          "metric-col custom-field-child-head",
                                                        class: {
                                                          "group-divider-left":
                                                            !_vm.compareMode &&
                                                            fieldIndex === 0,
                                                        },
                                                        attrs: {
                                                          "sort-key":
                                                            "custom:" +
                                                            config.id +
                                                            ":" +
                                                            field.key,
                                                          "active-key":
                                                            _vm.sortKey,
                                                          dir: _vm.sortDir,
                                                        },
                                                        on: {
                                                          sort: _vm.toggleSort,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              field.label
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "single-after-group-" +
                                                      config.id,
                                                    staticClass: "metric-col",
                                                    class: {
                                                      "group-divider-left":
                                                        !_vm.compareMode,
                                                    },
                                                    attrs: {
                                                      "sort-key":
                                                        "after:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedAfterLabel
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "single-delta-group-" +
                                                      config.id,
                                                    staticClass: "delta-col",
                                                    attrs: {
                                                      "sort-key":
                                                        "delta:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Δ\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          : _vm.isSingleGroupedReportHeader
                          ? [
                              _c(
                                "tr",
                                {
                                  staticClass:
                                    "sub-head-row group-sub-head-row",
                                },
                                [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "check-col",
                                      attrs: { rowspan: "2" },
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          "aria-label": "Select all products",
                                        },
                                        domProps: { checked: _vm.allChecked },
                                        on: { change: _vm.toggleAllChecked },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SortableTh",
                                    {
                                      staticClass: "product-col",
                                      attrs: {
                                        "sort-key": "product",
                                        "active-key": _vm.sortKey,
                                        dir: _vm.sortDir,
                                        rowspan: "2",
                                      },
                                      on: { sort: _vm.toggleSort },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Product\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SortableTh",
                                    {
                                      staticClass: "metric-col",
                                      attrs: {
                                        "sort-key": "optix",
                                        "active-key": _vm.sortKey,
                                        dir: _vm.sortDir,
                                        rowspan: "2",
                                      },
                                      on: { sort: _vm.toggleSort },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Optix™ Score\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.orderedConfigs, function (config) {
                                    return [
                                      _vm.compareMode
                                        ? _c(
                                            "SortableTh",
                                            {
                                              key:
                                                "single-grouped-before-group-" +
                                                config.id,
                                              staticClass:
                                                "metric-col group-divider-left",
                                              attrs: {
                                                "sort-key":
                                                  "before:" + config.id,
                                                "active-key": _vm.sortKey,
                                                dir: _vm.sortDir,
                                                rowspan: "2",
                                              },
                                              on: { sort: _vm.toggleSort },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.formattedBeforeLabel
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getConfigCustomFieldGroups(config),
                                        function (group, groupIndex) {
                                          return _c(
                                            "th",
                                            {
                                              key:
                                                "single-grouped-custom-field-group-head-" +
                                                config.id +
                                                "-" +
                                                group.key,
                                              staticClass:
                                                "metric-col custom-field-group-head",
                                              class: {
                                                "group-divider-left":
                                                  !_vm.compareMode &&
                                                  groupIndex === 0,
                                              },
                                              attrs: {
                                                colspan: group.children.length,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(group.label) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.compareMode
                                        ? _c(
                                            "SortableTh",
                                            {
                                              key:
                                                "single-grouped-delta-group-" +
                                                config.id,
                                              staticClass: "delta-col",
                                              attrs: {
                                                "sort-key":
                                                  "delta:" + config.id,
                                                "active-key": _vm.sortKey,
                                                dir: _vm.sortDir,
                                                rowspan: "2",
                                              },
                                              on: { sort: _vm.toggleSort },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Δ\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                {
                                  staticClass:
                                    "sub-head-row custom-field-sub-head-row",
                                },
                                [
                                  _vm._l(_vm.orderedConfigs, function (config) {
                                    return [
                                      _vm._l(
                                        _vm.getConfigCustomFieldGroups(config),
                                        function (group) {
                                          return _vm._l(
                                            group.children,
                                            function (field) {
                                              return _c(
                                                "SortableTh",
                                                {
                                                  key:
                                                    "single-grouped-custom-field-head-" +
                                                    config.id +
                                                    "-" +
                                                    group.key +
                                                    "-" +
                                                    field.key,
                                                  staticClass:
                                                    "metric-col custom-field-child-head",
                                                  attrs: {
                                                    "sort-key":
                                                      "custom:" +
                                                      config.id +
                                                      ":" +
                                                      field.key,
                                                    "active-key": _vm.sortKey,
                                                    dir: _vm.sortDir,
                                                  },
                                                  on: { sort: _vm.toggleSort },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(field.label) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        }
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          : [
                              _c(
                                "tr",
                                { staticClass: "top-head-row" },
                                [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "check-col",
                                      attrs: { rowspan: "3" },
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          "aria-label": "Select all products",
                                        },
                                        domProps: { checked: _vm.allChecked },
                                        on: { change: _vm.toggleAllChecked },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SortableTh",
                                    {
                                      staticClass: "product-col",
                                      attrs: {
                                        "sort-key": "product",
                                        "active-key": _vm.sortKey,
                                        dir: _vm.sortDir,
                                        rowspan: "3",
                                      },
                                      on: { sort: _vm.toggleSort },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Product\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SortableTh",
                                    {
                                      staticClass: "metric-col",
                                      attrs: {
                                        "sort-key": "optix",
                                        "active-key": _vm.sortKey,
                                        dir: _vm.sortDir,
                                        rowspan: "3",
                                      },
                                      on: { sort: _vm.toggleSort },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Optix™ Score\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.orderedConfigs, function (config) {
                                    return _c(
                                      "th",
                                      {
                                        key: "group-" + config.id,
                                        staticClass:
                                          "group-head group-divider-left",
                                        attrs: {
                                          colspan: _vm.getConfigColspan(config),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "config-head-wrap" },
                                          [
                                            config.icon
                                              ? [
                                                  _vm.getConfigIconType(
                                                    config
                                                  ) === "image"
                                                    ? _c("img", {
                                                        staticClass:
                                                          "config-custom-icon mr-1",
                                                        attrs: {
                                                          src: _vm.getConfigIconValue(
                                                            config
                                                          ),
                                                          alt: `${config.display_name} icon`,
                                                        },
                                                      })
                                                    : _vm.getConfigIconType(
                                                        config
                                                      ) === "lucide"
                                                    ? _c("i", {
                                                        staticClass:
                                                          "config-lucide-icon text-muted mr-1",
                                                        attrs: {
                                                          "data-lucide":
                                                            _vm.getConfigIconValue(
                                                              config
                                                            ),
                                                        },
                                                      })
                                                    : _c("i", {
                                                        class: [
                                                          _vm.getConfigIconValue(
                                                            config
                                                          ),
                                                          "text-muted",
                                                          "mr-1",
                                                        ],
                                                      }),
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(config.display_name)
                                              ),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                {
                                  staticClass:
                                    "sub-head-row group-sub-head-row",
                                },
                                [
                                  _vm._l(_vm.orderedConfigs, function (config) {
                                    return [
                                      config.is_pdp
                                        ? [
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "before-group-" +
                                                      config.id,
                                                    staticClass:
                                                      "metric-col group-divider-left",
                                                    attrs: {
                                                      "sort-key":
                                                        "before:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                      rowspan: "2",
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedBeforeLabel
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "SortableTh",
                                              {
                                                key: "text-group-" + config.id,
                                                staticClass: "metric-col",
                                                class: {
                                                  "group-divider-left":
                                                    !_vm.compareMode,
                                                },
                                                attrs: {
                                                  "sort-key":
                                                    "text:" + config.id,
                                                  "active-key": _vm.sortKey,
                                                  dir: _vm.sortDir,
                                                  rowspan: "2",
                                                },
                                                on: { sort: _vm.toggleSort },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Text\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "SortableTh",
                                              {
                                                key:
                                                  "images-group-" + config.id,
                                                staticClass: "metric-col",
                                                attrs: {
                                                  "sort-key":
                                                    "images:" + config.id,
                                                  "active-key": _vm.sortKey,
                                                  dir: _vm.sortDir,
                                                  rowspan: "2",
                                                },
                                                on: { sort: _vm.toggleSort },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Images\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "delta-group-" +
                                                      config.id,
                                                    staticClass: "delta-col",
                                                    attrs: {
                                                      "sort-key":
                                                        "delta:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                      rowspan: "2",
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Δ\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "before-group-" +
                                                      config.id,
                                                    staticClass:
                                                      "metric-col group-divider-left",
                                                    attrs: {
                                                      "sort-key":
                                                        "before:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                      rowspan: "2",
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedBeforeLabel
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.hasGroupedCustomFields(config)
                                              ? _vm._l(
                                                  _vm.getConfigCustomFieldGroups(
                                                    config
                                                  ),
                                                  function (group, groupIndex) {
                                                    return _c(
                                                      "th",
                                                      {
                                                        key:
                                                          "custom-field-group-head-" +
                                                          config.id +
                                                          "-" +
                                                          group.key,
                                                        staticClass:
                                                          "metric-col custom-field-group-head",
                                                        class: {
                                                          "group-divider-left":
                                                            !_vm.compareMode &&
                                                            groupIndex === 0,
                                                        },
                                                        attrs: {
                                                          colspan:
                                                            group.children
                                                              .length,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              group.label
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _vm.getFlatConfigCustomFields(
                                                  config
                                                ).length
                                              ? _vm._l(
                                                  _vm.getFlatConfigCustomFields(
                                                    config
                                                  ),
                                                  function (field, fieldIndex) {
                                                    return _c(
                                                      "SortableTh",
                                                      {
                                                        key:
                                                          "flat-custom-field-head-" +
                                                          config.id +
                                                          "-" +
                                                          field.key,
                                                        staticClass:
                                                          "metric-col custom-field-child-head",
                                                        class: {
                                                          "group-divider-left":
                                                            !_vm.compareMode &&
                                                            fieldIndex === 0,
                                                        },
                                                        attrs: {
                                                          "sort-key":
                                                            "custom:" +
                                                            config.id +
                                                            ":" +
                                                            field.key,
                                                          "active-key":
                                                            _vm.sortKey,
                                                          dir: _vm.sortDir,
                                                          rowspan: "2",
                                                        },
                                                        on: {
                                                          sort: _vm.toggleSort,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              field.label
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "after-group-" +
                                                      config.id,
                                                    staticClass: "metric-col",
                                                    class: {
                                                      "group-divider-left":
                                                        !_vm.compareMode,
                                                    },
                                                    attrs: {
                                                      "sort-key":
                                                        "after:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                      rowspan: "2",
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedAfterLabel
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _vm.compareMode
                                              ? _c(
                                                  "SortableTh",
                                                  {
                                                    key:
                                                      "delta-group-" +
                                                      config.id,
                                                    staticClass: "delta-col",
                                                    attrs: {
                                                      "sort-key":
                                                        "delta:" + config.id,
                                                      "active-key": _vm.sortKey,
                                                      dir: _vm.sortDir,
                                                      rowspan: "2",
                                                    },
                                                    on: {
                                                      sort: _vm.toggleSort,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Δ\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                {
                                  staticClass:
                                    "sub-head-row custom-field-sub-head-row",
                                },
                                [
                                  _vm._l(_vm.orderedConfigs, function (config) {
                                    return [
                                      !config.is_pdp &&
                                      _vm.hasGroupedCustomFields(config)
                                        ? [
                                            _vm._l(
                                              _vm.getConfigCustomFieldGroups(
                                                config
                                              ),
                                              function (group) {
                                                return _vm._l(
                                                  group.children,
                                                  function (field) {
                                                    return _c(
                                                      "SortableTh",
                                                      {
                                                        key:
                                                          "custom-field-head-" +
                                                          config.id +
                                                          "-" +
                                                          group.key +
                                                          "-" +
                                                          field.key,
                                                        staticClass:
                                                          "metric-col custom-field-child-head",
                                                        attrs: {
                                                          "sort-key":
                                                            "custom:" +
                                                            config.id +
                                                            ":" +
                                                            field.key,
                                                          "active-key":
                                                            _vm.sortKey,
                                                          dir: _vm.sortDir,
                                                        },
                                                        on: {
                                                          sort: _vm.toggleSort,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              field.label
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                )
                                              }
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.filteredProducts, function (item) {
                        return _c(
                          "tr",
                          {
                            key: item.rowKey,
                            attrs: {
                              "data-selected": _vm.checkedSet.has(item.rowKey),
                            },
                          },
                          [
                            _c("td", { staticClass: "check-col" }, [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  "aria-label": "Select " + item.product_name,
                                },
                                domProps: {
                                  checked: _vm.checkedSet.has(item.rowKey),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.toggleRowCheck(item.rowKey)
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "product-cell" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "product-thumb-wrap",
                                      on: {
                                        mouseenter: function ($event) {
                                          item.image
                                            ? _vm.showImageZoom($event, item)
                                            : null
                                        },
                                        mousemove: function ($event) {
                                          item.image
                                            ? _vm.moveImageZoom($event)
                                            : null
                                        },
                                        mouseleave: _vm.hideImageZoom,
                                      },
                                    },
                                    [
                                      item.image
                                        ? _c("img", {
                                            staticClass: "product-thumb",
                                            attrs: {
                                              src: item.image,
                                              alt: item.product_name,
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product-thumb product-thumb-placeholder",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    No image\n                  "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "product-meta" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-name",
                                        attrs: { title: item.product_name },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.product_name) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.getProductBrandLine(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "product-brand",
                                            attrs: {
                                              title:
                                                _vm.getProductBrandLine(item),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getProductBrandLine(item)
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "metric-cell" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "score-pill",
                                  class: _vm.overallScoreLevelClass(item),
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatPercent(item.optix_score)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.orderedConfigs, function (config) {
                              return [
                                config.is_pdp
                                  ? [
                                      _vm.compareMode
                                        ? _c(
                                            "td",
                                            {
                                              key:
                                                "cell-before-" +
                                                item.rowKey +
                                                "-" +
                                                config.id,
                                              staticClass:
                                                "metric-cell group-divider-left",
                                            },
                                            [
                                              item.metrics[config.id]
                                                .beforeReportUrl
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "score-pill score-pill-light",
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.openReportInFrame(
                                                            item.metrics[
                                                              config.id
                                                            ].beforeReportUrl,
                                                            item.product_name,
                                                            item.metrics[
                                                              config.id
                                                            ].beforeReportId ||
                                                              null,
                                                            item.metrics[
                                                              config.id
                                                            ]
                                                              .beforeReportUuid ||
                                                              null
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.metrics[
                                                              config.id
                                                            ].before
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "score-pill score-pill-light",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    -\n                  "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          key:
                                            "cell-text-" +
                                            item.rowKey +
                                            "-" +
                                            config.id,
                                          staticClass: "metric-cell",
                                          class: {
                                            "group-divider-left":
                                              !_vm.compareMode,
                                          },
                                        },
                                        [
                                          item.metrics[config.id].textReportUrl
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "score-pill",
                                                  class: _vm.scoreLevelClass(
                                                    item.metrics[config.id]
                                                      .textNumeric
                                                  ),
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openReportInFrame(
                                                        item.metrics[config.id]
                                                          .textReportUrl,
                                                        item.product_name,
                                                        item.metrics[config.id]
                                                          .textReportId || null,
                                                        item.metrics[config.id]
                                                          .textReportUuid ||
                                                          null
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        item.metrics[config.id]
                                                          .text
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass: "score-pill",
                                                  class: _vm.scoreLevelClass(
                                                    item.metrics[config.id]
                                                      .textNumeric
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        item.metrics[config.id]
                                                          .text
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          key:
                                            "cell-images-" +
                                            item.rowKey +
                                            "-" +
                                            config.id,
                                          staticClass: "metric-cell",
                                        },
                                        [
                                          item.metrics[config.id]
                                            .imagesReportUrl
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "score-pill",
                                                  class: _vm.scoreLevelClass(
                                                    item.metrics[config.id]
                                                      .imagesNumeric
                                                  ),
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openReportInFrame(
                                                        item.metrics[config.id]
                                                          .imagesReportUrl,
                                                        item.product_name,
                                                        item.metrics[config.id]
                                                          .imagesReportId ||
                                                          null,
                                                        item.metrics[config.id]
                                                          .imagesReportUuid ||
                                                          null,
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        item.metrics[config.id]
                                                          .images
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass: "score-pill",
                                                  class: _vm.scoreLevelClass(
                                                    item.metrics[config.id]
                                                      .imagesNumeric
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        item.metrics[config.id]
                                                          .images
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.compareMode
                                        ? _c(
                                            "td",
                                            {
                                              key:
                                                "cell-delta-" +
                                                item.rowKey +
                                                "-" +
                                                config.id,
                                              staticClass: "delta-cell",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: _vm.deltaClass(
                                                    item.metrics[config.id]
                                                      .delta
                                                  ),
                                                },
                                                [
                                                  _c("i", {
                                                    class: _vm.deltaIcon(
                                                      item.metrics[config.id]
                                                        .delta
                                                    ),
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.abs(
                                                          item.metrics[
                                                            config.id
                                                          ].delta
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : [
                                      _vm.compareMode
                                        ? _c(
                                            "td",
                                            {
                                              key:
                                                "cell-before-" +
                                                item.rowKey +
                                                "-" +
                                                config.id,
                                              staticClass:
                                                "metric-cell group-divider-left",
                                            },
                                            [
                                              item.metrics[config.id]
                                                .beforeReportUrl
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "score-pill score-pill-light",
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.openReportInFrame(
                                                            item.metrics[
                                                              config.id
                                                            ].beforeReportUrl,
                                                            item.product_name,
                                                            item.metrics[
                                                              config.id
                                                            ].beforeReportId ||
                                                              null,
                                                            item.metrics[
                                                              config.id
                                                            ]
                                                              .beforeReportUuid ||
                                                              null
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.metrics[
                                                              config.id
                                                            ].before
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "score-pill score-pill-light",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    —\n                  "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.metrics[config.id].customFields &&
                                      item.metrics[config.id].customFields
                                        .length
                                        ? _vm._l(
                                            item.metrics[config.id]
                                              .customFields,
                                            function (field, fieldIndex) {
                                              return _c(
                                                "td",
                                                {
                                                  key:
                                                    "cell-custom-" +
                                                    item.rowKey +
                                                    "-" +
                                                    config.id +
                                                    "-" +
                                                    field.key,
                                                  staticClass: "metric-cell",
                                                  class: {
                                                    "group-divider-left":
                                                      !_vm.compareMode &&
                                                      fieldIndex === 0,
                                                  },
                                                },
                                                [
                                                  item.metrics[config.id]
                                                    .reportUrl
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "score-pill score-pill-light",
                                                          class:
                                                            _vm.customFieldPillClass(
                                                              field
                                                            ),
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.openReportInFrame(
                                                                item.metrics[
                                                                  config.id
                                                                ].reportUrl,
                                                                item.product_name,
                                                                item.metrics[
                                                                  config.id
                                                                ].reportId ||
                                                                  null,
                                                                item.metrics[
                                                                  config.id
                                                                ].reportUuid ||
                                                                  null
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                field.value
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "score-pill score-pill-light",
                                                          class:
                                                            _vm.customFieldPillClass(
                                                              field
                                                            ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                field.value
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              )
                                            }
                                          )
                                        : _c(
                                            "td",
                                            {
                                              key:
                                                "cell-after-" +
                                                item.rowKey +
                                                "-" +
                                                config.id,
                                              staticClass: "metric-cell",
                                              class: {
                                                "group-divider-left":
                                                  !_vm.compareMode,
                                              },
                                            },
                                            [
                                              item.metrics[config.id].reportUrl
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass: "score-pill",
                                                      class:
                                                        _vm.scoreLevelClass(
                                                          item.metrics[
                                                            config.id
                                                          ].afterNumeric
                                                        ),
                                                      attrs: {
                                                        href: "#",
                                                        target: "_blank",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.openReportInFrame(
                                                            item.metrics[
                                                              config.id
                                                            ].reportUrl,
                                                            item.product_name,
                                                            item.metrics[
                                                              config.id
                                                            ].reportId || null,
                                                            item.metrics[
                                                              config.id
                                                            ].reportUuid || null
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.metrics[
                                                              config.id
                                                            ].after
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass: "score-pill",
                                                      class:
                                                        _vm.scoreLevelClass(
                                                          item.metrics[
                                                            config.id
                                                          ].afterNumeric
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.metrics[
                                                              config.id
                                                            ].after
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.compareMode
                                        ? _c(
                                            "td",
                                            {
                                              key:
                                                "cell-delta-" +
                                                item.rowKey +
                                                "-" +
                                                config.id,
                                              staticClass: "delta-cell",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: _vm.deltaClass(
                                                    item.metrics[config.id]
                                                      .delta
                                                  ),
                                                },
                                                [
                                                  _c("i", {
                                                    class: _vm.deltaIcon(
                                                      item.metrics[config.id]
                                                        .delta
                                                    ),
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.abs(
                                                          item.metrics[
                                                            config.id
                                                          ].delta
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                              ]
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.filteredProducts.length > 0 &&
                  (_vm.hasMoreProducts ||
                    _vm.isLoadingProducts ||
                    _vm.isLoadingMoreProducts)
                    ? _c("div", { staticClass: "dashboard-load-more-wrap" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-load-more",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.isLoadingProducts ||
                                _vm.isLoadingMoreProducts ||
                                !_vm.hasMoreProducts,
                            },
                            on: { click: _vm.loadMoreProducts },
                          },
                          [
                            _vm.isLoadingMoreProducts
                              ? _c("span", {
                                  staticClass:
                                    "spinner-border spinner-border-sm mr-2",
                                  attrs: {
                                    role: "status",
                                    "aria-hidden": "true",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isLoadingMoreProducts
                                    ? "Loading..."
                                    : "Load more products"
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "load-more-meta" }, [
                          _vm._v(
                            "\n          Showing " +
                              _vm._s(_vm.ajaxProducts.length) +
                              " of " +
                              _vm._s(_vm.productsPagination.total) +
                              "\n        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm.viewMode !== "table" && !_vm.activeReportUrl
            ? _c(
                "div",
                { staticClass: "chart-placeholder" },
                [
                  _c("ProductReportsScoreChart", {
                    attrs: { products: _vm.filteredProducts },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showOptimizeCatalogModal
        ? _c(
            "div",
            {
              staticClass: "optimize-catalog-modal-overlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeOptimizeCatalogModal.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "optimize-catalog-modal",
                  attrs: {
                    role: "dialog",
                    "aria-labelledby": "optimizeCatalogTitle",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "pt-3 pb-3 border-b optimize-catalog-header",
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-3 flex items-center gap-2 text-xs flex-wrap",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "inline-flex items-center rounded-md border bg-background p-0.5 h-8",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "border-0",
                                  class:
                                    _vm.optimizeCatalogView === "per_sku"
                                      ? "h-7 px-2.5 text-xs rounded-[5px] font-medium transition-colors bg-emerald-600 text-white"
                                      : "h-7 px-2.5 text-xs rounded-[5px] font-medium transition-colors text-muted-foreground hover:text-foreground",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.optimizeCatalogView = "per_sku"
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Per SKU\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "border-0",
                                  class:
                                    _vm.optimizeCatalogView === "group"
                                      ? "h-7 px-2.5 text-xs rounded-[5px] font-medium transition-colors bg-emerald-600 text-white"
                                      : "h-7 px-2.5 text-xs rounded-[5px] font-medium transition-colors text-muted-foreground hover:text-foreground",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.optimizeCatalogView = "group"
                                    },
                                  },
                                },
                                [_vm._v("\n              Group\n            ")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: () => {
                                    _vm.showOptimizeCatalogDatePicker = false
                                  },
                                  expression:
                                    "() => { showOptimizeCatalogDatePicker = false; }",
                                },
                              ],
                              staticClass: "relative",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "inline-flex items-center whitespace-nowrap border border-input hover:bg-accent hover:text-accent-foreground rounded-md px-3 h-8 min-w-[130px] text-xs bg-background gap-1.5 justify-start font-normal",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showOptimizeCatalogDatePicker =
                                        !_vm.showOptimizeCatalogDatePicker
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "lucide lucide-calendar h-3 w-3 text-muted-foreground shrink-0",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    },
                                    [
                                      _c("path", { attrs: { d: "M8 2v4" } }),
                                      _vm._v(" "),
                                      _c("path", { attrs: { d: "M16 2v4" } }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          width: "18",
                                          height: "18",
                                          x: "3",
                                          y: "4",
                                          rx: "2",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", { attrs: { d: "M3 10h18" } }),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.optimizeCatalogDueDateLabel) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showOptimizeCatalogDatePicker
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "absolute top-full left-0 mt-1 z-50 rounded-md border bg-popover text-popover-foreground shadow-md w-auto p-0",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-2 border-b flex flex-col gap-0.5",
                                        },
                                        _vm._l(
                                          [
                                            "This Friday",
                                            "Next Monday",
                                            "End of month",
                                            "End of quarter",
                                          ],
                                          function (preset) {
                                            return _c(
                                              "button",
                                              {
                                                key: preset,
                                                staticClass:
                                                  "border-0 text-left text-xs px-2 py-1.5 rounded hover:bg-muted",
                                                class:
                                                  _vm.optimizeCatalogDueDateLabel ===
                                                  preset
                                                    ? "bg-muted font-medium"
                                                    : "",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setOptimizeCatalogDatePreset(
                                                      preset
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(preset) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "optimize-datepicker-cal",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "optimize-datepicker-cal-header",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "optimize-datepicker-cal-nav",
                                                  attrs: {
                                                    type: "button",
                                                    "aria-label":
                                                      "Go to previous month",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.optimizeCatalogDatePickerPrev,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "lucide lucide-chevron-left h-4 w-4",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m15 18-6-6 6-6",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "optimize-datepicker-cal-month",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.optimizeCatalogDatePickerMonthLabel
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "optimize-datepicker-cal-nav",
                                                  attrs: {
                                                    type: "button",
                                                    "aria-label":
                                                      "Go to next month",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.optimizeCatalogDatePickerNext,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "lucide lucide-chevron-right h-4 w-4",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m9 18 6-6-6-6",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "optimize-datepicker-cal-weekdays",
                                            },
                                            _vm._l(
                                              [
                                                "Su",
                                                "Mo",
                                                "Tu",
                                                "We",
                                                "Th",
                                                "Fr",
                                                "Sa",
                                              ],
                                              function (d) {
                                                return _c("span", { key: d }, [
                                                  _vm._v(_vm._s(d)),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "optimize-datepicker-cal-days",
                                            },
                                            _vm._l(
                                              _vm.optimizeCatalogDatePickerDays,
                                              function (day, idx) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: idx,
                                                    staticClass:
                                                      "optimize-datepicker-cal-day",
                                                    class: {
                                                      "is-other-month":
                                                        !day.currentMonth,
                                                      "is-selected":
                                                        day.isSelected,
                                                      "is-today": day.isToday,
                                                    },
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.pickOptimizeCatalogDate(
                                                          day
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(day.day) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.optimizeCatalogView === "per_sku"
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: () => {
                                        _vm.showOptimizeCatalogToggleAll = false
                                      },
                                      expression:
                                        "() => { showOptimizeCatalogToggleAll = false; }",
                                    },
                                  ],
                                  staticClass: "relative",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "inline-flex items-center justify-center whitespace-nowrap border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md px-3 h-8 text-xs gap-1.5 font-normal",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showOptimizeCatalogToggleAll =
                                            !_vm.showOptimizeCatalogToggleAll
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "lucide lucide-list-checks h-3.5 w-3.5 text-muted-foreground",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: { d: "m3 17 2 2 4-4" },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: { d: "m3 7 2 2 4-4" },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: { d: "M13 6h8" },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: { d: "M13 12h8" },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: { d: "M13 18h8" },
                                          }),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n              Toggle across all\n              "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "inline-flex items-center rounded-full border-transparent ml-1 h-4 px-1.5 text-[10px] font-semibold bg-emerald-100 text-emerald-700",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.optimizeCatalogTotalActiveCount
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showOptimizeCatalogToggleAll
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute top-full left-0 mt-1 z-50 rounded-md border bg-popover text-popover-foreground shadow-md w-64 p-1.5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-col" },
                                            _vm._l(
                                              _vm.kpiCards,
                                              function (card) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: card.id,
                                                    staticClass:
                                                      "flex items-center gap-2 px-2 py-1.5 rounded border-0 hover:bg-muted text-left",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleAllForIssue(
                                                          card.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "h-4 w-4 rounded border flex items-center justify-center shrink-0",
                                                        class:
                                                          _vm
                                                            .optimizeCatalogToggleAllCounts[
                                                            card.id
                                                          ] &&
                                                          _vm
                                                            .optimizeCatalogToggleAllCounts[
                                                            card.id
                                                          ].active > 0
                                                            ? "bg-emerald-600 border-emerald-600"
                                                            : "bg-white border-input",
                                                      },
                                                      [
                                                        _vm
                                                          .optimizeCatalogToggleAllCounts[
                                                          card.id
                                                        ] &&
                                                        _vm
                                                          .optimizeCatalogToggleAllCounts[
                                                          card.id
                                                        ].active ===
                                                          _vm
                                                            .optimizeCatalogToggleAllCounts[
                                                            card.id
                                                          ].total &&
                                                        _vm
                                                          .optimizeCatalogToggleAllCounts[
                                                          card.id
                                                        ].total > 0
                                                          ? _c(
                                                              "svg",
                                                              {
                                                                staticClass:
                                                                  "lucide lucide-check h-3 w-3 text-white",
                                                                attrs: {
                                                                  xmlns:
                                                                    "http://www.w3.org/2000/svg",
                                                                  width: "24",
                                                                  height: "24",
                                                                  viewBox:
                                                                    "0 0 24 24",
                                                                  fill: "none",
                                                                  stroke:
                                                                    "currentColor",
                                                                  "stroke-width":
                                                                    "3",
                                                                  "stroke-linecap":
                                                                    "round",
                                                                  "stroke-linejoin":
                                                                    "round",
                                                                },
                                                              },
                                                              [
                                                                _c("path", {
                                                                  attrs: {
                                                                    d: "M20 6 9 17l-5-5",
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm
                                                              .optimizeCatalogToggleAllCounts[
                                                              card.id
                                                            ] &&
                                                            _vm
                                                              .optimizeCatalogToggleAllCounts[
                                                              card.id
                                                            ].active > 0
                                                          ? _c("span", {
                                                              staticClass:
                                                                "h-0.5 w-2 bg-white rounded",
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-xs flex-1 truncate",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(card.name)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-[10px] text-muted-foreground shrink-0",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm
                                                                .optimizeCatalogToggleAllCounts[
                                                                card.id
                                                              ]
                                                                ? _vm
                                                                    .optimizeCatalogToggleAllCounts[
                                                                    card.id
                                                                  ].active
                                                                : 0
                                                            ) +
                                                            "/" +
                                                            _vm._s(
                                                              _vm
                                                                .optimizeCatalogToggleAllCounts[
                                                                card.id
                                                              ]
                                                                ? _vm
                                                                    .optimizeCatalogToggleAllCounts[
                                                                    card.id
                                                                  ].total
                                                                : 0
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.closeOptimizeDefaultOwnerDropdown,
                                  expression:
                                    "closeOptimizeDefaultOwnerDropdown",
                                },
                              ],
                              staticClass:
                                "optimize-dropdown-wrap optimize-select-footer ml-auto",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "optimize-dropdown-trigger optimize-dropdown-trigger-full optimize-select-wrap optimize-select-wrap-owner",
                                  attrs: { type: "button" },
                                  on: {
                                    click:
                                      _vm.toggleOptimizeDefaultOwnerDropdown,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "bi bi-person optimize-select-prefix",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "optimize-dropdown-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getOptimizeAuthorName(
                                            _vm.optimizeCatalogDefaultOwnerId
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "lucide lucide-chevron-down h-4 w-4 opacity-50 optimize-select-chevron",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: { d: "m6 9 6 6 6-6" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.optimizeDefaultOwnerDropdownOpen
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "optimize-dropdown-menu p-1",
                                      attrs: { role: "presentation" },
                                    },
                                    _vm._l(
                                      _vm.optimizeCatalogAuthors,
                                      function (author) {
                                        return _c(
                                          "button",
                                          {
                                            key: author.id,
                                            staticClass:
                                              "optimize-dropdown-option",
                                            class: {
                                              "is-selected":
                                                _vm.optimizeCatalogDefaultOwnerId ===
                                                author.id,
                                            },
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectOptimizeDefaultOwner(
                                                  author.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "optimize-dropdown-option-indicator",
                                              },
                                              [
                                                _vm.optimizeCatalogDefaultOwnerId ===
                                                author.id
                                                  ? _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "lucide lucide-check h-4 w-4",
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                          width: "24",
                                                          height: "24",
                                                          viewBox: "0 0 24 24",
                                                          fill: "none",
                                                          stroke:
                                                            "currentColor",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M20 6 9 17l-5-5",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(author.fullName)),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.optimizeCatalogView === "per_sku"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "px-6 py-3 overflow-y-auto space-y-1.5 optimize-catalog-issues-list",
                        },
                        _vm._l(
                          _vm.optimizeCatalogModalProducts,
                          function (product) {
                            return _c(
                              "div",
                              {
                                key: product.rowKey,
                                staticClass:
                                  "w-full rounded-lg border transition-all px-3 py-2.5 border-emerald-500/50 bg-emerald-50/30",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-3" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-package h-4 w-4 shrink-0 text-emerald-700",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M12 22V12" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "m7.5 4.27 9 5.15" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-1 min-w-0 flex items-center gap-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-medium text-sm text-foreground truncate",
                                          },
                                          [_vm._v(_vm._s(product.product_name))]
                                        ),
                                        _vm._v(" "),
                                        _vm.getProductOverallScore(product) !==
                                        null
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "inline-flex items-center rounded-full border-transparent text-[10px] font-medium shrink-0 px-1.5 py-0",
                                                class:
                                                  _vm.getProductOverallScore(
                                                    product
                                                  ) < 50
                                                    ? "bg-red-100 text-red-700"
                                                    : _vm.getProductOverallScore(
                                                        product
                                                      ) < 85
                                                    ? "bg-amber-100 text-amber-700"
                                                    : "bg-emerald-100 text-emerald-700",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.getProductOverallScore(
                                                        product
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        product.product_id && product.is_asin
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-[11px] text-muted-foreground font-mono shrink-0",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(product.product_id)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        staticClass:
                                          "flex items-center justify-between rounded-md border border-input px-2 py-1 h-7 w-[130px] text-[11px] bg-background shrink-0 border-dashed focus:outline-none",
                                        domProps: {
                                          value:
                                            _vm.optimizeCatalogSkuOwners[
                                              product.rowKey
                                            ],
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.$set(
                                              _vm.optimizeCatalogSkuOwners,
                                              product.rowKey,
                                              Number($event.target.value)
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.optimizeCatalogAuthors,
                                        function (author) {
                                          return _c(
                                            "option",
                                            {
                                              key: author.id,
                                              domProps: { value: author.id },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(author.fullName) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-2 flex items-center justify-end gap-1 flex-wrap",
                                  },
                                  _vm._l(_vm.kpiCards, function (card) {
                                    return _c(
                                      "button",
                                      {
                                        key: card.id,
                                        staticClass:
                                          "inline-flex items-center gap-1 h-6 px-1.5 rounded border text-[11px] whitespace-nowrap shrink-0 transition-colors",
                                        class:
                                          _vm.optimizeCatalogSkuSelections[
                                            product.rowKey
                                          ] &&
                                          _vm.optimizeCatalogSkuSelections[
                                            product.rowKey
                                          ][card.id]
                                            ? "border-emerald-400 bg-emerald-50 text-emerald-700 hover:bg-emerald-100"
                                            : "border-border bg-background text-muted-foreground hover:text-foreground",
                                        attrs: {
                                          type: "button",
                                          title: card.name,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSkuIssue(
                                              product.rowKey,
                                              card.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(card.name) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "px-6 py-3 overflow-y-auto space-y-1.5 optimize-catalog-issues-list",
                        },
                        _vm._l(_vm.optimizeCatalogIssues, function (issue) {
                          return _c(
                            "div",
                            {
                              key: issue.id,
                              staticClass: "optimize-issue-row",
                              class: { "is-selected": issue.selected },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center gap-3 optimize-issue-main-row",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "optimize-issue-check",
                                      class: { "is-selected": issue.selected },
                                      attrs: {
                                        type: "button",
                                        "aria-label": issue.selected
                                          ? "Deselect issue"
                                          : "Select issue",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleOptimizeIssue(issue)
                                        },
                                      },
                                    },
                                    [
                                      issue.selected
                                        ? _c("i", {
                                            staticClass: "bi bi-check",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "flex items-center gap-3 flex-1 min-w-0 text-left optimize-issue-content",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleOptimizeIssue(issue)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "optimize-issue-icon",
                                        class: issue.iconClass,
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "flex-1 min-w-0" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "flex items-center gap-2",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-medium text-sm text-foreground truncate",
                                                },
                                                [_vm._v(_vm._s(issue.name))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "optimize-issue-count",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(issue.number) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "click-outside",
                                          rawName: "v-click-outside",
                                          value:
                                            _vm.optimizeIssueOwnerDropdownId ===
                                            issue.id
                                              ? _vm.closeOptimizeIssueOwnerDropdown
                                              : null,
                                          expression:
                                            "optimizeIssueOwnerDropdownId === issue.id ? closeOptimizeIssueOwnerDropdown : null",
                                        },
                                      ],
                                      staticClass:
                                        "flex optimize-dropdown-wrap optimize-select-issue-owner",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "optimize-dropdown-trigger optimize-dropdown-trigger-full optimize-select-wrap optimize-select-wrap-owner border-dashed",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleOptimizeIssueOwnerDropdown(
                                                issue.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-person optimize-select-prefix",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "optimize-dropdown-value",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getOptimizeAuthorName(
                                                    issue.authorId === null
                                                      ? _vm.optimizeCatalogDefaultOwnerId
                                                      : issue.authorId
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "lucide lucide-chevron-down h-4 w-4 opacity-50 optimize-select-chevron",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: { d: "m6 9 6 6 6-6" },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.optimizeIssueOwnerDropdownId ===
                                      issue.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "optimize-dropdown-menu p-1",
                                              style: _vm.optimizeDropdownStyle,
                                              attrs: { role: "presentation" },
                                            },
                                            _vm._l(
                                              _vm.optimizeCatalogAuthors,
                                              function (author) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: author.id,
                                                    staticClass:
                                                      "optimize-dropdown-option",
                                                    class: {
                                                      "is-selected":
                                                        (issue.authorId === null
                                                          ? _vm.optimizeCatalogDefaultOwnerId
                                                          : issue.authorId) ===
                                                        author.id,
                                                    },
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectOptimizeIssueOwner(
                                                          issue,
                                                          author.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "optimize-dropdown-option-indicator",
                                                      },
                                                      [
                                                        (issue.authorId === null
                                                          ? _vm.optimizeCatalogDefaultOwnerId
                                                          : issue.authorId) ===
                                                        author.id
                                                          ? _c(
                                                              "svg",
                                                              {
                                                                staticClass:
                                                                  "lucide lucide-check h-4 w-4",
                                                                attrs: {
                                                                  xmlns:
                                                                    "http://www.w3.org/2000/svg",
                                                                  width: "24",
                                                                  height: "24",
                                                                  viewBox:
                                                                    "0 0 24 24",
                                                                  fill: "none",
                                                                  stroke:
                                                                    "currentColor",
                                                                  "stroke-width":
                                                                    "2",
                                                                  "stroke-linecap":
                                                                    "round",
                                                                  "stroke-linejoin":
                                                                    "round",
                                                                },
                                                              },
                                                              [
                                                                _c("path", {
                                                                  attrs: {
                                                                    d: "M20 6 9 17l-5-5",
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(author.fullName)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "shrink-0 bg-border h-[1px] w-full",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-6 py-3 bg-muted/30 flex items-center gap-3 flex-wrap optimize-catalog-footer",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "ml-auto flex items-center gap-2" },
                        [
                          _vm.optimizeCatalogView === "per_sku"
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "optimize-btn-build-brief",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.optimizeCatalogCreateBriefCount ===
                                        0,
                                    },
                                    on: { click: _vm.openSkuBriefPreviewModal },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-file-text h-4 w-4",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M14 2v4a2 2 0 0 0 2 2h4",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M10 9H8" } }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M16 13H8" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M16 17H8" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n              Create briefs (" +
                                        _vm._s(
                                          _vm.optimizeCatalogCreateBriefCount
                                        ) +
                                        ")\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 rounded-md px-3 gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white border-0",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.optimizeCatalogTotalActiveCount ===
                                        0,
                                    },
                                    on: { click: _vm.optimizeWithAiPerSku },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-sparkles h-4 w-4",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M20 3v4" } }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M22 5h-4" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M4 17v2" } }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M5 18H3" } }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n              Optimize with AI\n            "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "button",
                                  {
                                    staticClass: "optimize-btn-build-brief",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        !_vm.optimizeCatalogSelectedIssues
                                          .length,
                                    },
                                    on: { click: _vm.buildBrief },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-file-text h-4 w-4",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M14 2v4a2 2 0 0 0 2 2h4",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M10 9H8" } }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M16 13H8" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M16 17H8" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n              Create brief\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 rounded-md px-3 gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white border-0",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        !_vm.optimizeCatalogSelectedIssues
                                          .length,
                                    },
                                    on: { click: _vm.optimizeWithAiGroup },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-sparkles h-4 w-4",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M20 3v4" } }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M22 5h-4" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M4 17v2" } }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M5 18H3" } }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n              Optimize with AI\n            "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "optimize-catalog-close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.closeOptimizeCatalogModal },
                    },
                    [_c("i", { staticClass: "bi bi-x" })]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ProductReportsDashboardBriefModal", {
        ref: "briefModal",
        attrs: {
          "show-content-brief-modal": _vm.showContentBriefModal,
          "optimize-catalog-product-filter": _vm.optimizeCatalogProductFilter,
          "optimize-catalog-product-filters":
            _vm.optimizeCatalogProductFilterOptions,
          "optimize-catalog-issues": _vm.optimizeCatalogIssues,
          "total-product-count": _vm.selectedIssuesProductCount,
          "optimize-catalog-authors": _vm.optimizeCatalogAuthors,
          "optimize-catalog-default-owner-id":
            _vm.optimizeCatalogDefaultOwnerId,
          "optimize-catalog-due-date": _vm.optimizeCatalogDueDate,
        },
        on: {
          close: _vm.closeContentBriefModal,
          "submit-brief": _vm.createBriefFromModal,
        },
      }),
      _vm._v(" "),
      _vm.showSkuBriefPreviewModal
        ? _c("ProductReportsDashboardSkuBriefModal", {
            attrs: {
              briefs: _vm.optimizeCatalogSkuBriefs,
              "is-submitting": _vm.isCreatingBriefs,
              "submit-results": _vm.skuBriefResults,
            },
            on: {
              submit: _vm.createAllSkuBriefs,
              close: _vm.closeSkuBriefPreviewModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRefreshAllConfirm
        ? _c(
            "div",
            {
              staticClass: "refresh-confirm-overlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.cancelRefreshAllReports.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "refresh-confirm-modal",
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "refreshAllConfirmTitle",
                  },
                },
                [
                  _c(
                    "h5",
                    {
                      staticClass: "refresh-confirm-title",
                      attrs: { id: "refreshAllConfirmTitle" },
                    },
                    [
                      _vm._v(
                        "\n        Refresh reports for the active prompts?\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "refresh-confirm-text" }, [
                    _vm._v(
                      "\n        Reports for the active dashboard prompts will be re-run across all lists,\n        including products added directly by URL.\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "refresh-confirm-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "refresh-confirm-btn refresh-confirm-btn--cancel",
                        attrs: { type: "button" },
                        on: { click: _vm.cancelRefreshAllReports },
                      },
                      [_vm._v("\n          Cancel\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        ref: "refreshConfirmBtn",
                        staticClass:
                          "refresh-confirm-btn refresh-confirm-btn--primary",
                        attrs: { type: "button" },
                        on: { click: _vm.confirmRefreshAllReports },
                      },
                      [_vm._v("\n          Refresh all\n        ")]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade optix-email-modal",
          attrs: {
            id: "sendToEmailModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "sendToEmailModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.closeSendToEmailModal },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "div",
                        { staticClass: "custom-control custom-checkbox mb-2" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sendEmailForm.allConfigs,
                                expression: "sendEmailForm.allConfigs",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: { id: "sendAllConfigs", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.sendEmailForm.allConfigs
                              )
                                ? _vm._i(_vm.sendEmailForm.allConfigs, null) >
                                  -1
                                : _vm.sendEmailForm.allConfigs,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.sendEmailForm.allConfigs,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.sendEmailForm,
                                          "allConfigs",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.sendEmailForm,
                                          "allConfigs",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.sendEmailForm,
                                      "allConfigs",
                                      $$c
                                    )
                                  }
                                },
                                _vm.toggleAllConfigs,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-control-label",
                              attrs: { for: "sendAllConfigs" },
                            },
                            [
                              _vm._v(
                                "\n                All configs\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm._v("Configs:"),
                      ]),
                      _vm._v(" "),
                      _c("Multiselect", {
                        staticClass: "send-email-multiselect",
                        attrs: {
                          options: _vm.sendEmailConfigOptions,
                          multiple: true,
                          "close-on-select": false,
                          "clear-on-select": false,
                          "preserve-search": true,
                          searchable: true,
                          "show-labels": false,
                          "track-by": "value",
                          label: "label",
                          placeholder: "Select one or more configs",
                        },
                        on: { input: _vm.handleSelectedConfigsChange },
                        model: {
                          value: _vm.sendEmailForm.selectedConfigs,
                          callback: function ($$v) {
                            _vm.$set(_vm.sendEmailForm, "selectedConfigs", $$v)
                          },
                          expression: "sendEmailForm.selectedConfigs",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "custom-control custom-checkbox mb-2" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sendEmailForm.onlyIssueProducts,
                              expression: "sendEmailForm.onlyIssueProducts",
                            },
                          ],
                          staticClass: "custom-control-input",
                          attrs: {
                            id: "sendOnlyIssueProducts",
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.sendEmailForm.onlyIssueProducts
                            )
                              ? _vm._i(
                                  _vm.sendEmailForm.onlyIssueProducts,
                                  null
                                ) > -1
                              : _vm.sendEmailForm.onlyIssueProducts,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.sendEmailForm.onlyIssueProducts,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.sendEmailForm,
                                      "onlyIssueProducts",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.sendEmailForm,
                                      "onlyIssueProducts",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.sendEmailForm,
                                  "onlyIssueProducts",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: { for: "sendOnlyIssueProducts" },
                          },
                          [
                            _vm._v(
                              "\n                Only low-scoring products\n              "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.sendEmailForm.onlyIssueProducts
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "font-weight-bold" }, [
                          _vm._v("Threshold:"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.sendEmailForm.threshold,
                                expression: "sendEmailForm.threshold",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              min: "0",
                              max: "100",
                              placeholder: "70",
                            },
                            domProps: { value: _vm.sendEmailForm.threshold },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.sendEmailForm,
                                  "threshold",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm._m(4),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sendEmailForm.onlyIssueProducts
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "font-weight-bold" }, [
                          _vm._v("Email summary text:"),
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sendEmailForm.summaryTemplate,
                              expression: "sendEmailForm.summaryTemplate",
                            },
                          ],
                          staticClass: "form-control send-email-textarea",
                          attrs: {
                            rows: "4",
                            placeholder:
                              "Example: {{notOptimizedProducts}} of your {{totalProducts}} products are not mobile optimized",
                          },
                          domProps: {
                            value: _vm.sendEmailForm.summaryTemplate,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.sendEmailForm,
                                "summaryTemplate",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("small", { staticClass: "form-text text-muted" }, [
                          _vm._v(
                            "\n              Available placeholders:\n              "
                          ),
                          _c("code", {
                            domProps: {
                              textContent: _vm._s("{{notOptimizedProducts}}"),
                            },
                          }),
                          _vm._v(",\n              "),
                          _c("code", {
                            domProps: {
                              textContent: _vm._s("{{totalProducts}}"),
                            },
                          }),
                          _vm._v(",\n              "),
                          _c("code", {
                            domProps: { textContent: _vm._s("{{threshold}}") },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Email Recipients:"),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sendEmailForm.recipients,
                          expression: "sendEmailForm.recipients",
                        },
                      ],
                      staticClass: "form-control send-email-textarea",
                      attrs: {
                        rows: "4",
                        placeholder:
                          "Enter email addresses (one per line or separated by commas)",
                      },
                      domProps: { value: _vm.sendEmailForm.recipients },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.sendEmailForm,
                            "recipients",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-modal-cancel",
                      attrs: { type: "button" },
                      on: { click: _vm.closeSendToEmailModal },
                    },
                    [
                      _c("i", { staticClass: "bi bi-x-lg mr-1" }),
                      _vm._v("\n            Cancel\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-modal-send",
                      attrs: { type: "button", disabled: _vm.isSendingEmail },
                      on: { click: _vm.sendProductsReportEmail },
                    },
                    [
                      !_vm.isSendingEmail
                        ? _c("i", { staticClass: "bi bi-send mr-1" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSendingEmail
                        ? _c("span", {
                            staticClass:
                              "spinner-border spinner-border-sm mr-2",
                            attrs: { role: "status", "aria-hidden": "true" },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.isSendingEmail ? "Sending..." : "Send Email"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.imageZoom.visible
        ? _c(
            "div",
            {
              staticClass: "product-image-zoom",
              style: {
                left: `${_vm.imageZoom.x}px`,
                top: `${_vm.imageZoom.y}px`,
              },
            },
            [
              _c("img", {
                attrs: { src: _vm.imageZoom.src, alt: _vm.imageZoom.alt },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-icon p-0 dropdown-toggle no-caret",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "bi bi-three-dots" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "report-loading-content" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border",
          staticStyle: {
            width: "3rem",
            height: "3rem",
            "margin-bottom": "1rem",
          },
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
      _vm._v(" "),
      _c("div", [_vm._v("Loading Report...")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex flex-col space-y-1 optimize-catalog-heading" },
      [
        _c(
          "h2",
          {
            staticClass: "font-semibold text-lg optimize-catalog-title mb-0",
            attrs: { id: "optimizeCatalogTitle" },
          },
          [_vm._v("\n            Optimize catalog\n          ")]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "text-muted-foreground text-sm optimize-catalog-subtitle",
          },
          [
            _vm._v(
              "\n            Pick the work, assign it, and optimize.\n          "
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h5",
      { staticClass: "modal-title", attrs: { id: "sendToEmailModalLabel" } },
      [
        _c("i", { staticClass: "bi bi-envelope-fill mr-2 text-info" }),
        _vm._v("\n            Send Optix Products Report\n          "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("%")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }